/**
 * Basic input that can accept prop with extra class names to change styling.
 * 
 * @returns {JSX.Element}
 * 
 * @category Components - UI
 */
export const Input = ({
    type = "text", 
    name, 
    placeholder, 
    value, 
    onChange, 
    onBlur, 
    disabled = false, 
    error = false, 
    className = null
}) => {

    const getClasses = () => {
        let classes = `border border-gray-300 rounded mb-1 min-w-72 max-w-md h-9 p-2 mr-4 ${className}`
        
        if(error){
            classes += " border-red-500"
        }
        if(disabled){
            classes += " cursor-not-allowed bg-gray-200"
        }
        return classes
    }

    return(
        <input 
            type={type} 
            name={name} 
            value={value} 
            onChange={onChange} 
            onBlur={onBlur} 
            className={getClasses()}
            placeholder={disabled ? null : placeholder}
            disabled={disabled}
            autoComplete="on"
        />
    )
}